import Content from "./cards/content";
import React from "react";
import Layout from "layout";

export function BankSuratPage() {
  return (
    <Layout subnavbar={{ title: "Bank Surat", keysTab: "listBankSurat" }}>
      <Content />
    </Layout>
  );
}
